import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FourAndHalfStars from "./assets/stars-4.5.svg";
import FourStars from "./assets/stars-4.svg";
import FiveStars from "./assets/stars-5.svg";
var starSVGList = {
    4: /*#__PURE__*/ _jsx(FourStars, {}),
    4.5: /*#__PURE__*/ _jsx(FourAndHalfStars, {}),
    5: /*#__PURE__*/ _jsx(FiveStars, {})
};
export function TrustpilotStars(param) {
    var className = param.className, starRating = param.starRating, starRatingLabel = param.starRatingLabel;
    var alt = "".concat(starRatingLabel, " rating on Trustpilot");
    var _starRating;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        "data-testid": "trustpilotStarsDefault",
        children: /*#__PURE__*/ _jsxs("svg", {
            "aria-labelledby": "starRating",
            viewBox: "0 0 512 96",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    id: "starRating",
                    children: alt
                }),
                (_starRating = starSVGList[starRating]) !== null && _starRating !== void 0 ? _starRating : /*#__PURE__*/ _jsx(FiveStars, {})
            ]
        })
    });
}
export default TrustpilotStars;
